import axios from 'axios';


const api = axios.create({
    baseURL: `/api`,
    headers: {
        'Content-type': 'application/json; charset=utf-8',
    }
});

export default api;
